// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gOz4","left":"styles_left__2mDsC"};